import { memo, useCallback, useRef } from 'react';
import { BzTextArea, BzButton, BzInputText } from '../../../components';
import { Container, Row, Col } from 'react-bootstrap';

const NewNote = ({ onSaveNotes, strTitle, setStrIdea, strTags, strIdea, setStrTitle, strSetTags }) => {

    const titleRef = useRef()
    const descriptionRef = useRef()
    const tagsRef = useRef()

    const saveNotesOnClickHandler = useCallback(() => {
        console.log(
            titleRef.current.value,
            descriptionRef.current.value,
            tagsRef.current.value,
        );
        onSaveNotes(titleRef.current.value, descriptionRef.current.value, tagsRef.current.value,)
        titleRef.current.value = ''
        descriptionRef.current.value = ''
        tagsRef.current.value = ''
    }, [onSaveNotes])


    return (
        <Container fluid className='px-3'>
            <Row className='g-0 mb-2'>
                <Col>
                    <div className='form-control'>
                        <div className='mb-3'>
                            <BzInputText type='text' ref={titleRef} placeholder={'Type title here...'} className='p-0 font-regular color-text bdr-none' />
                        </div>
                        <div className='mb-3'>
                            <BzTextArea ref={descriptionRef} placeholder={'Type your idea here...'} className='p-0 form-control form-control-sm font-regular color-text bdr-none resizenone' />
                        </div>
                    </div>
                </Col>
            </Row>
            <Row className='g-0 mb-2'>
                <Col>
                    <div className='font-regular font-size2 color-subtext mb-2'>Tags</div>
                    <BzInputText type='text' ref={tagsRef} placeholder={'Add comma (,) to separate tags'} className='font-regular color-text' />
                </Col>
            </Row>
            <Row className='g-0 mb-2'>
                <Col className='d-grid'>
                    <BzButton className='btn btn-md btn-primary text-capitalize' onClick={saveNotesOnClickHandler}>Save Note</BzButton>
                </Col>
            </Row>
            <Row className='g-0 mb-2'>
                <Col className='d-flex justify-content-center'>
                    <div className='font-regular font-size3 color-subtext'>View saved notes from "My Notes" tab</div>
                </Col>
            </Row>
        </Container>


    );
};

export default memo(NewNote);